import React from 'react';
export function CheckboxCircle(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M45 .75C20.561.75.75 20.562.75 45S20.561 89.25 45 89.25c24.438 0 44.25-19.812 44.25-44.25S69.438.75 45 .75zm27.176 35.486l-32.86 32.859a1.385 1.385 0 01-1.956-.002L17.822 49.499a1.378 1.378 0 01.002-1.954l6.816-6.797c.258-.258.609-.403.975-.403h.002c.365 0 .717.147.977.406l11.758 11.79 25.064-25.065a1.382 1.382 0 011.955 0l6.805 6.806c.258.259.406.61.406.977 0 .366-.148.718-.406.977z"
  }));
}